import sendEventsToHawkeye from '../../components/fseManagementSystem/utils/webViewUtils/sendEventsToHawkeye';

const sendHawkeyeEvent = (statusCode, startTime, obj) => {
  const endTime = Date.now();
  const responseTime = endTime - startTime;
  sendEventsToHawkeye(
    statusCode,
    responseTime,
    Object.keys(obj).length,
    JSON.stringify(obj),
  );
};
export default sendHawkeyeEvent;
